var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',[_c('v-btn',{attrs:{"icon":"","type":"file"},on:{"click":_vm.click}},[_c('v-icon',{attrs:{"large":""}},[_vm._v(_vm._s(_vm.iconName))])],1)],1),_c('div',[_c('span',[_vm._v(_vm._s(_vm.annotation))])])])}
var staticRenderFns = []

export { render, staticRenderFns }